import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import DataVVue3 from '@kjgl77/datav-vue3'
import 'element-plus/dist/index.css'


const app = createApp(App)

app.use(ElementPlus)
app.use(DataVVue3)
app.mount('#app')